import React, { useState, useEffect } from 'react';
import { confirmEmail, ConfirmEmailResult } from '@/services/users';
import { Trans } from '@lingui/react/macro';
import { CustomRedirect } from '../navigation';
import SplashPage from './SplashPage';
import { useQueryString } from '@/utils/hooks';
import { withRouter, RouteComponentProps } from 'react-router';
import { InternalLinkButton } from '@/components/Buttons';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';

type OwnProps = RouteComponentProps<any>;

interface QueryStringParams {
    token: string;
}

const ConfirmEmail: React.FC<OwnProps> = ({ location }) => {
    const [result, setResult] = useState<ConfirmEmailResult | null>(null);
    const { token } = useQueryString<QueryStringParams>(location);
    const user = useSelector((state: IState) => state.global.user);

    useEffect(() => {
        const loadData = async () => {
            const response = await confirmEmail(token);
            setResult(response.result);
        };

        loadData();
    }, [token]);

    const renderMessage = () => {
        switch (result) {
            case ConfirmEmailResult.Success:
                return <Trans>Your email is confirmed.</Trans>;
            case ConfirmEmailResult.InvalidToken:
                return <Trans>Invalid token.</Trans>;
            case ConfirmEmailResult.AlreadyConfirmed:
                return <Trans>your email has been confirmed earlier. You can continue to log in.</Trans>;
            case null:
                return <Trans>Confirming email.</Trans>;
        }
    };

    if (result === ConfirmEmailResult.AlreadyConfirmed && user && user.isLoggedIn) {
        return <CustomRedirect to="/" />;
    }

    return (
        <SplashPage>
            <h3>{renderMessage()}</h3>

            {result !== null && (
                <InternalLinkButton color="primary" size="large" to="/">
                    <Trans>Proceed to login</Trans>
                </InternalLinkButton>
            )}
        </SplashPage>
    );
};
export default withRouter(ConfirmEmail);
